import Api from 'App/api'

export const getChecklists = Api.get({
  controller: 'checklists',
  action: 'list',
})

export const postSaveChecklistWatchVideo = Api.post({
  controller: 'checklists',
  action: 'saveWatchVideo',
})

export const getChecklistAmount = Api.post({
  controller : 'checklists',
  action : 'getChecklistAmount'
})

export const getMoveInSchedulerTime = Api.get({
  controller: 'move_in_scheduler',
  action: 'getTimes',
})

export const postMoveInSchedulerTime = Api.post({
  controller: 'move_in_scheduler',
  action: 'saveTime',
})

export const postAddToCalendar = Api.post({
  controller: 'move_in_scheduler',
  action: 'addToCalendar',
})

export const postInsertEventToCalendar = Api.post({
  controller: 'move_in_scheduler',
  action: 'insertEventToGoogleCalendar',
})
